import React from 'react';
import type { FilterResultsToolPart } from '../../types/conciergeToolTypes';
import { isCallState, isOutputState } from './types';

export function FilterResultsPart({ part }: { part: FilterResultsToolPart }) {
  if (isCallState(part.state)) return null;

  if (isOutputState(part.state) && part.output) {
    const { originalCount, filteredCount, appliedFilters } = part.output;
    if (originalCount === 0) return null;
    return (
      <div className="concierge-search-results">
        <div className="concierge-search-summary">
          Filtered {originalCount} → {filteredCount} products
          {appliedFilters?.length > 0 && <span> ({appliedFilters.join(', ')})</span>}
        </div>
      </div>
    );
  }

  return null;
}
